// extracted by mini-css-extract-plugin
module.exports = {"container":"Chip_container__kkS8J","children":"Chip_children__JTGd0"};